import { definePropType } from '@types-vue/props'
import { LanguageItem } from '@com/components/ai-translate/index.type'

export const IconResolverProp = {
  resolver: definePropType<(code: LanguageItem['code']) => string>(Function),
}
